const alerts = Array.from(document.querySelectorAll('.j-alert'));

if (alerts.length) {
    alerts.forEach((item) => {
        item.addEventListener('click', () => {
            item.classList.add('is-hidden');
        });
    });
}
